import { message, Tabs, Select, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    InputNumberItem
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";
import TimePickerItem from "../../../../Components/TimePickerItem";
import { secondsToHms, timeToSeconds } from "../../../../Components/TimeConvertions";
import moment from "moment";

const { TabPane } = Tabs;
const { Option } = Select;

class EditarDescanso extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasProyectos: [],
        objetoProyectos: [],
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarEditarDescanso(codigo) {
        this.props.cerrarEditarDescanso(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "descansos/datosDescanso",
                { empresaId: this.props.empresaId, descansoId: this.props.descansoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...res.data.data,
                        inicio: secondsToHms(res.data.data.inicioSeg),
                        final: secondsToHms(res.data.data.finalSeg),
                    });
                } else {
                    message.error("Error no se encontro informacion del descanso");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        const esFlexible = values.modalidad === 2;

        let inicioSeg = null;
        let finalSeg = null;

        if (!esFlexible) {
            inicioSeg = timeToSeconds(values.inicio);
            finalSeg = timeToSeconds(values.final);

            // Validaciones rápidas (front)
            if (inicioSeg == null || finalSeg == null) {
                this.setState({ loading: false });
                message.error("Selecciona Inicio y Fin.");
                return;
            }
            if (inicioSeg < 0 || inicioSeg > 86399 || finalSeg < 0 || finalSeg > 86399) {
                this.setState({ loading: false });
                message.error("Hora inválida.");
                return;
            }
        }

        // Si tu descanso NO puede cruzar medianoche, valida aquí:
        // if (finalSeg <= inicioSeg) { ... }

        const payload = {
            ...values,
            empresaId: this.props.empresaId,
            descansoId: this.props.descansoId,

            // Reemplaza los campos por segundos (null cuando el descanso es flexible)
            inicioSeg: inicioSeg,
            finalSeg: finalSeg,

            // (Opcional) si quieres guardar también formato legible:
            // inicioTexto: values.inicio?.format?.("HH:mm:ss"),
            // finalTexto: values.final?.format?.("HH:mm:ss"),
        };
        this.setState({ loading: true });
        axios
            .post(
                "descansos/editarDescanso",
                payload,
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado un descanso");
                    this.formRef.current.resetFields();
                    this.cerrarEditarDescanso(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede editar el descanso");
                } else {
                    message.error("Hubo un error y el descanso no se editó");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Editar Descanso"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarDescanso.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="editarDescanso"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            name="nombre"
                            label="Nombre"
                            required
                            max={100}
                            margin
                            pattern
                        >
                            <InputItem placeholder="Nombre" />
                        </FormItem>
                        <FormItem
                            name="descripcion"
                            label="Descripción"
                            margin
                            pattern
                        >
                            <TextAreItem
                                placeholder="Descripción"
                            />
                        </FormItem>
                        <FormItem
                            name="modalidad"
                            label="Modalidad"
                            margin
                            initialValue={1}
                            required
                            tooltip="Fijo: el descanso tiene una hora de inicio y fin determinada. Flexible: solo se define la duración en minutos y el empleado puede tomarla en cualquier momento de su turno."
                        >
                            <SelectItem placeholder="Modalidad">
                                <Option value={1}>Fijo (hora determinada)</Option>
                                <Option value={2}>Flexible (minutos, cualquier hora)</Option>
                            </SelectItem>
                        </FormItem>
                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) =>
                                getFieldValue("modalidad") !== 2 ? (
                                    <FormItem
                                        name="tipoCalculo"
                                        label="Tipo de cálculo"
                                        margin
                                        initialValue={1}
                                        required
                                    >
                                        <SelectItem placeholder="Tipo de cálculo">
                                            <Option value={1}>Deducir automaticamente</Option>
                                            <Option value={2}>Checada obligatoria</Option>
                                        </SelectItem>
                                    </FormItem>
                                ) : null}
                        </FormItem>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Basico" key="1">
                                <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) =>
                                        getFieldValue("modalidad") === 2 ? (
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="duracionDescansoMin"
                                                        label="Duración (minutos)"
                                                        required
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={60}
                                                        tooltip="El empleado podrá tomar estos minutos de descanso en cualquier momento de su turno."
                                                    >
                                                        <InputNumberItem placeholder="Duración (minutos)" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="inicio"
                                                        label="Inicio"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(12).minute(0).second(0)} // Opcional: valor inicial a las 12:00:00
                                                    >
                                                        <TimePickerItem placeholder="Inicio" />
                                                    </FormItem>
                                                    <FormItem
                                                        name="duracionDescansoMin"
                                                        label="Duración (minutos)"
                                                        required
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={60} // Opcional: duración inicial de 60 minutos
                                                    >
                                                        <InputNumberItem placeholder="Duración (minutos)" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="final"
                                                        label="Fin"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(13).minute(0).second(0)} // Opcional: valor inicial a las 13:00:00
                                                    >
                                                        <TimePickerItem placeholder="Fin" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        )}
                                </FormItem>
                            </TabPane>
                            <TabPane tab="Reglas" key="2">
                                <Row>
                                    <Col span={12}>
                                        <FormItem
                                            name="checadaDuplicadaBase"
                                            label="Checada duplicada"
                                            margin
                                            valuePropName="checked"
                                            specialLayoutSwitch
                                        >
                                            <SwitchItem />
                                        </FormItem>
                                        <FormItem
                                            name="basadoEnEstadoDispositivo"
                                            label="Basado en estado dispositivo"
                                            margin
                                            valuePropName="checked"
                                            specialLayoutSwitch
                                        >
                                            <SwitchItem />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem shouldUpdate noStyle>
                                            {({ getFieldValue }) =>
                                                getFieldValue("checadaDuplicadaBase") ? (
                                                    <FormItem
                                                        name="checadaDuplicadaMin"
                                                        label="Checada duplicada min"
                                                        required
                                                        margin
                                                        initialValue={1}
                                                    >
                                                        <InputNumberItem placeholder="Checada duplicada min" />
                                                    </FormItem>
                                                ) : null}
                                        </FormItem>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tab="Checadas" key="3">
                                <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                        const esFlexible = getFieldValue("modalidad") === 2;
                                        const mostrarChecadas = esFlexible || getFieldValue("tipoCalculo") === 2;
                                        if (!mostrarChecadas) return null;
                                        return (
                                            <Row>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="entradasSalidasMultiples"
                                                        label="Entradas y salidas múltiples"
                                                        margin
                                                        valuePropName="checked"
                                                        specialLayoutSwitch
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                    {!esFlexible && (
                                                        <FormItem
                                                            name="retornoTemprano"
                                                            label="Retorno temprano"
                                                            margin
                                                            pattern
                                                            required
                                                            initialValue={1}
                                                        >
                                                            <SelectItem placeholder="Retorno temprano">
                                                                <Option value={1}>Ignorar</Option>
                                                                <Option value={2}>Mover a trabajo normal</Option>
                                                                <Option value={3}>Mover a tiempo extra normal</Option>
                                                                <Option value={4}>Mover a tiempo extra de fin de semana</Option>
                                                                <Option value={5}>Mover a tiempo extra de festivo</Option>
                                                            </SelectItem>
                                                        </FormItem>
                                                    )}
                                                    <FormItem
                                                        name="retardoDescanso"
                                                        label={esFlexible ? "Si excede los minutos" : "Retardo descanso"}
                                                        margin
                                                        pattern
                                                        required
                                                        initialValue={1}
                                                        tooltip={esFlexible ? "Qué hacer con los minutos que el empleado tome de más sobre su descanso permitido." : undefined}
                                                    >
                                                        <SelectItem placeholder={esFlexible ? "Si excede los minutos" : "Retardo descanso"}>
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Mover a trabajo normal</Option>
                                                            <Option value={3}>Mover a tiempo extra normal</Option>
                                                            <Option value={4}>Mover a tiempo extra de fin de semana</Option>
                                                            <Option value={5}>Mover a tiempo extra de festivo</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="minimoDescansoMin"
                                                        label="Mínimo descanso"
                                                        required
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0} // Opcional: mínimo descanso inicial de 60 minutos
                                                    >
                                                        <InputNumberItem placeholder="Mínimo descanso" />
                                                    </FormItem>
                                                    {!esFlexible && (
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) =>
                                                                getFieldValue("retornoTemprano") !== 1 ? (
                                                                    <FormItem
                                                                        name="minRetornoTempranoMin"
                                                                        label="Min retorno temprano"
                                                                        required
                                                                        margin
                                                                        type="number"
                                                                        max={1440}
                                                                        initialValue={0} // Opcional: mínimo retorno temprano inicial de 60 minutos
                                                                    >
                                                                        <InputNumberItem placeholder="Min retorno temprano" />
                                                                    </FormItem>
                                                                ) : null}
                                                        </FormItem>
                                                    )}
                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("retardoDescanso") !== 1 ? (
                                                                <FormItem
                                                                    name="toleranciaRetardoMin"
                                                                    label="Tolerancia retardo"
                                                                    required
                                                                    margin
                                                                    type="number"
                                                                    max={1440}
                                                                    initialValue={0} // Opcional: tolerancia retardo inicial de 60 minutos
                                                                >
                                                                    <InputNumberItem placeholder="Tolerancia retardo" />
                                                                </FormItem>
                                                            ) : null}
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        );
                                    }}
                                </FormItem>
                            </TabPane>
                        </Tabs>
                    </Form>
                </ModalItem >
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarDescanso);
